import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { Avatar } from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useTheme } from "@mui/material/styles";
import { PrimaryLink } from "./Header.styles";
import { useAuth } from "../../_auth/useAuth";
import { AuthCodeLoginOptions } from "../../_auth/types";
import { grey } from "@mui/material/colors";

export const Account: React.FC = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const { isAuthenticated, user, logout } = useAuth();

    const [anchorEl, setAnchorEl] = useState<HTMLElement>();
    const open = Boolean(anchorEl);

    const handleLogout = (event: React.MouseEvent<HTMLElement>) => {
        logout({ localOnly: true });
        setAnchorEl(undefined);
        navigate("/");
    };

    const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(undefined);
    };

    const handleProfile = () => {
        setAnchorEl(undefined);
        navigate("/account-settings");
    };

    return (
        <>
            {isAuthenticated && (
                <>
                    <Tooltip
                        title={ user?[user.first_name, user.last_name].filter(Boolean).join(" ") : ""}>
                        <IconButton
                            aria-label="current user account"
                            aria-controls="menu-appbar-profile"
                            aria-haspopup="true"
                            onClick={handleMenu}
                            sx={{
                                color: 'inherit',
                                padding: '6px',
                                '&:hover': { backgroundColor: theme.daPalette.black.light }
                            }}
                        >
                            <Avatar
                                sx={{
                                    backgroundColor: theme.palette.primary.main,
                                    width: 32,
                                    height: 32,
                                    fontSize: '1rem'
                                }}
                            >
                                {user
                                    ? ((user.first_name ?? "")[0]?.toUpperCase() ?? "") +
                                      ((user.last_name ?? "")[0]?.toUpperCase() ?? "") || "?"
                                    : ""}
                            </Avatar>
                        </IconButton>
                    </Tooltip>
                    <Menu
                        id="menu-appbar-profile"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                        PaperProps={{
                            elevation: 0,
                            sx: theme => ({
                                overflow: "visible",
                                filter: { xs: undefined, sm: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))" },
                                mt: { xs: 0, sm: .5 },
                                minWidth: 180,
                                maxWidth: 240,
                                left: { xs: 0, sm: 'auto' },
                                right: { xs: 0, sm: 'auto' },
                                '&::before': {
                                    content: { xs: 'none', sm: '""' },
                                    display: { xs: 'none', sm: 'block' },
                                    position: "absolute",
                                    top: 0,
                                    right: 16,
                                    width: 10,
                                    height: 10,
                                    bgcolor: theme.palette.background.paper,
                                    transform: "translateY(-50%) rotate(45deg)",
                                    zIndex: 0
                                }
                            })
                        }}
                        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                    >
                        <MenuItem
                            onClick={handleProfile}
                            sx={{
                                transition: 'background 0.2s, color 0.2s, font-weight 0.2s',
                                cursor: 'pointer',
                                '&:hover': {
                                    background: theme => theme.palette.primary.light,
                                    color: theme => theme.palette.primary.contrastText,
                                    fontWeight: 600,
                                },
                            }}
                        >
                            Profile
                        </MenuItem>
                        <MenuItem
                            onClick={handleLogout}
                            sx={{
                                transition: 'background 0.2s, color 0.2s, font-weight 0.2s',
                                cursor: 'pointer',
                                '&:hover': {
                                    background: theme => theme.palette.primary.light,
                                    color: theme => theme.palette.primary.contrastText,
                                    fontWeight: 600,
                                },
                            }}
                        >
                            Logout
                        </MenuItem>
                    </Menu>
                </>
            )}
            {/*: (*/}
            {/*    <PrimaryLink to="/login">Login</PrimaryLink>*/}
            {/*)}*/}
        </>
    );
}